import React, { FunctionComponent } from 'react';

export interface ProfilProps {
  width?: string;
  height?: string;
}

const ProfilIcon: FunctionComponent<ProfilProps> = (props): JSX.Element => {
  /* istanbul ignore next */
  return (
    <svg
      height="23px"
      viewBox="-32 0 496 496"
      width="23px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="color:s#FEDAC6;"
        d="M349.726,153.369h-8.52v51.122h8.52c14.118,0,25.561-11.443,25.561-25.561
	S363.835,153.369,349.726,153.369z"
      />
      <path
        fill="color:s#F5C4B0;"
        d="M136.715,178.931c0,14.118,11.443,25.561,25.561,25.561h8.52v-51.122h-8.52
	C148.158,153.369,136.715,164.812,136.715,178.931z"
      />
      <path
        fill="color:s#FECB66;"
        d="M349.726,153.369l10.054-51.719c3.297-19.631-9.952-38.214-29.583-41.511
	c-1.994-0.332-4.013-0.494-6.032-0.494l0,0c-5.095-15.252-19.367-25.544-35.445-25.561H187.838L170.797,8.522l-8.52,8.52
	c-23.525,23.525-23.533,61.662-0.017,85.187c0.009,0.009,0.009,0.017,0.017,0.017h153.367L349.726,153.369z"
      />
      <path
        fill="color:s#DBDBDB;"
        d="M375.798,349.935l-61.773-8.52L256.001,374.9l-58.024-33.144l-61.773,8.52
	c-33.724,4.507-58.961,33.196-59.132,67.226v93.725H434.93v-93.725C434.93,383.352,409.65,354.46,375.798,349.935z"
      />
      <polygon
        fill="color:s#FEDAC6;"
        points="314.025,341.756 307.123,340.818 307.123,281.176 204.879,281.176 204.879,340.818 
	197.977,341.756 256.001,374.9 "
      />
      <g>
        <polygon
          fill="color:s#EAEAEA;"
          points="204.879,408.982 256.001,374.9 204.879,340.818 187.838,340.818 	"
        />
        <polygon
          fill="color:s#EAEAEA;"
          points="256.001,374.9 307.123,408.982 324.164,340.818 307.123,340.818 	"
        />
      </g>
      <polyline
        fill="color:s#2E6AA3;"
        points="230.44,511.227 238.96,417.502 230.44,391.941 256.001,374.9 281.562,391.941 
	273.042,417.502 281.562,511.227 "
      />
      <path
        fill="color:s#F5C4B0;"
        d="M307.123,328.379v-47.203H204.879v47.203C243.22,344.993,268.782,344.993,307.123,328.379z"
      />
      <path
        fill="color:s#BFBFBF;"
        d="M77.072,417.502v93.725h34.082V358.541C90.083,370.708,77.089,393.176,77.072,417.502z"
      />
      <path
        fill="color:s#FEDAC6;"
        d="M349.726,153.369v48.566c-0.009,24.036-6.135,47.663-17.808,68.675l0,0
	c-15.32,27.564-44.383,44.655-75.917,44.647l0,0c-31.534,0.009-60.597-17.083-75.917-44.647l0,0
	c-11.673-21.011-17.799-44.638-17.808-68.675v-99.689h153.367L349.726,153.369z"
      />
      <path
        fill="color:s#F5C4B0;"
        d="M196.358,102.247h-34.082v99.689c0.009,24.036,6.135,47.663,17.808,68.675
	c8.52,15.252,21.48,27.555,37.149,35.275C187.838,221.533,196.358,102.247,196.358,102.247z"
      />
      <path
        fill="color:s#F5AD76;"
        d="M146.429,45.331c-5.061,20.44,0.954,42.031,15.848,56.916h136.327
	C201.811,102.247,162.276,68.165,146.429,45.331z"
      />
      <path
        d="M349.726,213.012h-8.52v-17.041h8.52c9.398,0,17.041-7.643,17.041-17.041c0-9.398-7.643-17.041-17.041-17.041h-8.52v-17.041
	h8.52c18.796,0,34.082,15.286,34.082,34.082S368.522,213.012,349.726,213.012z"
      />
      <path
        d="M170.797,213.012h-8.52c-18.796,0-34.082-15.286-34.082-34.082s15.286-34.082,34.082-34.082h8.52v17.041h-8.52
	c-9.398,0-17.041,7.643-17.041,17.041c0,9.398,7.643,17.041,17.041,17.041h8.52V213.012z"
      />
      <path
        d="M264.521,230.053H238.96c-2.675,0-5.189-1.253-6.799-3.391c-1.61-2.139-2.13-4.899-1.389-7.472l17.041-59.643l16.385,4.686
	l-13.948,48.779h14.263v17.041H264.521z"
      />
      <path
        d="M256.018,323.778c-0.017,0-0.034,0-0.051,0c-34.593,0-66.527-18.779-83.338-49.035
	c-12.346-22.213-18.873-47.391-18.881-72.798v-99.697c0-4.703,3.817-8.52,8.52-8.52h153.367c2.846,0,5.504,1.423,7.089,3.792
	l34.082,51.122c0.929,1.397,1.431,3.042,1.431,4.729v48.566c-0.009,25.408-6.544,50.586-18.881,72.807
	C322.554,304.99,290.619,323.778,256.018,323.778z M255.992,306.737c0.008,0,0.017,0,0.017,0c28.424,0,54.65-15.43,68.453-40.267
	c10.94-19.699,16.726-42.014,16.734-64.542v-45.985l-30.12-45.175h-140.28v91.168c0.009,22.528,5.794,44.843,16.734,64.534
	c13.803,24.846,40.029,40.267,68.444,40.267C255.984,306.737,255.992,306.737,255.992,306.737z"
      />
      <path
        d="M248.929,264.135h-9.969v-17.041h9.969c13.266-0.009,25.74-5.172,35.13-14.553l12.048,12.056
	C283.496,257.191,266.745,264.126,248.929,264.135z"
      />
      <circle cx="204.913" cy="170.41" r="17.041" />
      <circle cx="307.158" cy="170.41" r="17.041" />
      <path
        d="M358.127,163.296l-16.811-2.803l10.054-60.239c1.218-7.259-0.46-14.553-4.729-20.534
	c-4.269-5.981-10.608-9.952-17.859-11.17c-1.517-0.256-3.238-0.443-4.61-0.375c-0.009,0-0.009,0-0.017,0
	c-3.664,0-6.927-2.343-8.077-5.819c-3.945-11.801-14.945-19.733-27.376-19.75H187.838c-2.846,0-5.504-1.423-7.089-3.792
	l-11.281-16.913l-1.176,1.167c-9.764,9.764-15.149,22.758-15.149,36.57c0,13.82,5.376,26.805,15.141,36.57l-12.039,12.065
	c-26.814-26.822-26.814-70.447,0-97.252l8.52-8.52c1.806-1.798,4.328-2.718,6.867-2.454c2.539,0.247,4.831,1.627,6.245,3.749
	l14.519,21.77h96.323c17.799,0.017,33.741,10.233,41.324,25.936c0.528,0.068,1.039,0.145,1.568,0.23
	c11.75,1.968,22.017,8.393,28.927,18.089s9.628,21.497,7.651,33.238L358.127,163.296z"
      />
      <path
        d="M85.593,511.227H68.552v-93.725c0-38.257,28.594-70.932,66.527-76.011l61.279-8.137v-35.138h17.041v42.602
	c0,4.269-3.161,7.881-7.396,8.444l-68.674,9.117c-29.489,3.945-51.736,29.353-51.736,59.115V511.227z"
      />
      <path
        d="M443.45,511.227h-17.041v-93.725c0-29.762-22.238-55.178-51.744-59.115l-68.666-9.117c-4.235-0.562-7.396-4.175-7.396-8.444
	v-42.602h17.041v35.138l61.27,8.137c37.933,5.07,66.536,37.754,66.536,76.011L443.45,511.227L443.45,511.227z"
      />
      <rect x="136.749" y="443.063" width="17.041" height="68.163" />
      <rect x="358.28" y="443.063" width="17.041" height="68.163" />
      <path
        d="M204.879,417.502c-1.039,0-2.079-0.187-3.076-0.571c-2.582-0.997-4.516-3.195-5.189-5.879l-17.041-68.163l16.53-4.124
	l14.11,56.431l41.06-27.376l9.449,14.178l-51.122,34.082C208.184,417.025,206.531,417.502,204.879,417.502z"
      />
      <path
        d="M256.001,383.42c-1.457,0-2.914-0.375-4.226-1.125l-59.643-34.082l8.452-14.791l55.417,31.67l55.417-31.67l8.452,14.791
	l-59.643,34.082C258.915,383.046,257.458,383.42,256.001,383.42z"
      />
      <path
        d="M307.123,417.502c-1.653,0-3.306-0.486-4.729-1.431l-51.122-34.082l9.449-14.178l41.06,27.376l14.11-56.431l16.521,4.124
	l-17.041,68.163c-0.665,2.684-2.607,4.882-5.189,5.879C309.202,417.315,308.163,417.502,307.123,417.502z"
      />
      <path
        d="M238.926,512.002l-16.973-1.551l8.359-91.944l-7.958-23.874l16.163-5.393l8.52,25.561c0.366,1.116,0.511,2.301,0.4,3.468
	L238.926,512.002z"
      />
      <path
        d="M273.067,512.002l-8.52-93.725c-0.102-1.176,0.034-2.352,0.409-3.468l8.52-25.561l16.155,5.393l-7.958,23.874l8.359,91.944
	L273.067,512.002z"
      />
      <rect x="238.994" y="408.982" width="34.082" height="17.041" />
    </svg>
  );
};

export default ProfilIcon;
